<template>
    <div>
        <div class="greyBody">
            <div class="goback">
                <img src="../../assets/countyQB/左箭头.png" alt="" style="position: absolute;;left: 0;top: 1px;width: 8px;height: 16px;">
                <div class="gobackText" @click="$router.push('/buyCountyProduction');">上一步</div>
            </div>
            <div class="greyText1">购买专业版套件</div>
            <div class="jindutiao">
                <img src="../../assets/countyQB/蓝1.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 265px;width: 30px;height: 30px;">
                <div class="jindutiaoText1">需求确认</div>
                <div class="jindutiaoLine1"></div>
                <div class="jindutiaoLine2"></div>
                <img src="../../assets/countyQB/灰2.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 445px;width: 30px;height: 30px;">
                <div class="jindutiaoText2">订单提交</div>
                <div class="jindutiaoLine2" style="width: 150px;left: 475px;"></div>
                <img src="../../assets/countyQB/灰3.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 625px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="left: 602px;">审核与支付</div>
                <div class="jindutiaoLine2" style="width: 150px;left: 655px;"></div>
                <img src="../../assets/countyQB/灰4.png" alt="" class="jindutiaoIcon1" style="position: absolute;left:805px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="left: 782px;">交付</div>
                <div class="jindutiaoLine2" style="width: 150px;left: 835px;"></div>
                <img src="../../assets/countyQB/灰5.png" alt="" class="jindutiaoIcon1" style="position: absolute;left:985px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="left: 962px;">评价</div>
            </div>
            <div class="orderInfo">
                <div class="orderBlue">订单基本信息</div>
                <div v-if="areaLength==1">
                    <img :src="areaImg" alt="" style="position: absolute;width: 300px;height: 200px;top: 104px;left: 55px;border-radius: 8px;">
                </div>
                <div v-else-if="areaLength==2">
                    <img :src="areaImg" alt="" style="position: absolute;width: 300px;height: 200px;top: 94px;left: 75px;opacity: 0.25;border-radius: 8px;">
                    <img :src="areaImg" alt="" style="position: absolute;width: 300px;height: 200px;top: 114px;left: 55px;border-radius: 8px;">
                </div>
                <div v-else>
                    <img :src="areaImg" alt="" style="position: absolute;width: 300px;height: 200px;top:100px;left: 75px;opacity: 0.25;border-radius: 8px;">
                    <img :src="areaImg" alt="" style="position: absolute;width: 300px;height: 200px;top: 107px;left: 65px;opacity: 0.25;border-radius: 8px;">
                    <img :src="areaImg" alt="" style="position: absolute;width: 300px;height: 200px;top: 114px;left: 55px;border-radius: 8px;">
                </div>
                <div class="orderImgText" @click="isShadow=1">专业版套件价格说明</div>
                <div class="orderText1" style="margin-top: 104px;">
                    <div class="orderText2">选购区域名称</div>
                    <div class="orderText3">{{ areaName }}</div>
                </div>
                <div class="orderText1">
                    <div class="orderText2">选购区域面积</div>
                    <div class="orderText3">{{ areaSize }} km²</div>
                </div>
                <div class="orderText1">
                    <div class="orderText2">选购时相</div>
                    <div class="orderText3">{{ areaQuarter }}</div>
                </div>
                <div class="orderText1">
                    <div class="orderText2">结算价格</div>
                    <div class="orderText3">￥ {{ areaPrice }}</div>
                </div>
            </div>
            <div class="contractInfo">
                <div class="orderBlue">合同信息</div>
                <div class="contractSelect">选择合同模式
                    <div class="redTip" id="redTip1Id" v-show="redTip1==1">请您输入合同委托方(甲方)名称</div>
                </div>
                <div class="contractSelect1">
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="contractType=='电子'">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="contractType=='纸质'" @click="contractType='电子'">
                    <div class="contractText1">电子合同</div>
                    <div class="contractText2">(默认)</div>
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 320px;" v-if="contractType=='纸质'">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 320px;cursor: pointer;" v-if="contractType=='电子'" @click="contractType='纸质'">
                    <div class="contractText1" style="left: 347px;">纸质合同</div>
                </div>
                <div class="contractName" id="contractNameId">委托方(甲方)名称</div>
                <div class="contractInput" id="contractInputId">
                    <input type="text" class="conInputContent" placeholder="请输入委托方(甲方)名称" maxlength="50" v-model="clientName" @focus="inputBlack(1)">
                </div>
                <!-- <div class="contractSelect" style="margin-top: 50px;">发票信息
                    <div class="redTip" id="redTip2Id" v-show="redTip2==1">请您完整填写发票信息</div>
                </div>
                <div class="contractSelect1">
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="invoiceType==1">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="invoiceType!=1" @click="invoiceType=1">
                    <div class="contractText1">个人电子发票</div>
                    <div class="contractText2">(默认)</div>
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 395px;" v-if="invoiceType==2">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 395px;cursor: pointer;" v-if="invoiceType!=2" @click="invoiceType=2">
                    <div class="contractText1" style="left: 423px;">企业普通电子发票</div>
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left:770px;" v-if="invoiceType==3">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 770px;cursor: pointer;" v-if="invoiceType!=3" @click="invoiceType=3">
                    <div class="contractText1" style="left: 800px;">企业增值税专用发票(纸质)</div>
                </div>
                <div class="greyInvoice" :class="[invoiceType==2 ? 'greyInvoice1':'', invoiceType==3 ? 'greyInvoice2':'']">
                    <div class="qyInvoice" v-if="invoiceType==2">
                        <div class="qyText1" id="qyText1Id">单位名称：</div>
                        <div class="greyInput" id="greyInput1Id">
                            <input type="text" class="inputContent" placeholder="" v-model="qyCompany" @focus="inputBlack(2)"/>
                        </div>
                        <div class="qyText1" id="qyText2Id" style="top: 65px;">纳税人识别号：</div>
                        <div class="greyInput" id="greyInput2Id" style="top: 55px;">
                            <input type="text" class="inputContent" placeholder="" v-model="qyNumber" @focus="inputBlack(3)"/>
                        </div>
                        <div class="qyText1" id="qyText2Id" style="top: 120px;">发票备注：</div>
                        <div class="greyRemarks" style="top: 120px;">
                            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="showSellerInfoStatus=='1'">
                            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="showSellerInfoStatus!='1'" @click="showSellerInfoStatus='1'">
                            <div class="contractText1">销售方银行信息</div>
                            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;" v-if="showSellerInfoStatus=='0'">
                            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;cursor: pointer;" v-if="showSellerInfoStatus!='0'" @click="showSellerInfoStatus='0'">
                            <div class="contractText1" style="left: 223px;">不展示销售方银行信息</div>
                        </div>
                    </div>
                    <div class="zpInvoice" v-if="invoiceType==3">
                        <div class="qyText1" id="qyText3Id">单位名称：</div>
                        <div class="greyInput" id="greyInput3Id">
                            <input type="text" class="inputContent" placeholder="" v-model="zpCompany" @focus="inputBlack(4)"/>
                        </div>
                        <div class="qyText1" style="top: 65px;" id="qyText4Id">纳税人识别号：</div>
                        <div class="greyInput" style="top: 55px;" id="greyInput4Id">
                            <input type="text" class="inputContent" placeholder="" v-model="zpNumber" @focus="inputBlack(5)"/>
                        </div>
                        <div class="qyText1" id="qyText2Id" style="top: 120px;">发票备注：</div>
                        <div class="greyRemarks" style="top: 120px;">
                            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="showSellerInfoStatus=='1'">
                            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="showSellerInfoStatus!='1'" @click="showSellerInfoStatus='1'">
                            <div class="contractText1">销售方银行信息</div>
                            <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;" v-if="showSellerInfoStatus=='0'">
                            <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 195px;cursor: pointer;" v-if="showSellerInfoStatus!='0'" @click="showSellerInfoStatus='0'">
                            <div class="contractText1" style="left: 223px;">不展示销售方银行信息</div>
                        </div>
                        <div class="zpLine"></div>
                        <div class="zpText1">资质信息</div>
                        <div class="qyText1" style="top: 215px;" id="qyText5Id">注册地址：</div>
                        <div class="greyInput" style="top: 205px;"  id="greyInput5Id">
                            <input type="text" class="inputContent" placeholder="" v-model="address" @focus="inputBlack(6)"/>
                        </div>
                        <div class="qyText1" style="top: 270px;"  id="qyText6Id">注册电话：</div>
                        <div class="greyInput" style="top: 260px;"  id="greyInput6Id">
                            <input type="text" class="inputContent" placeholder="" v-model="phone" @focus="inputBlack(7)"/>
                        </div>
                        <div class="qyText1" style="top: 325px;"  id="qyText7Id">开户银行：</div>
                        <div class="greyInput" style="top: 315px;" id="greyInput7Id">
                            <input type="text" class="inputContent" placeholder="" v-model="bank" @focus="inputBlack(8)"/>
                        </div>
                        <div class="qyText1" style="top: 380px;"  id="qyText8Id">银行账号：</div>
                        <div class="greyInput" style="top: 370px;" id="greyInput8Id">
                            <input type="text" class="inputContent" placeholder="" v-model="bankNumber" @focus="inputBlack(9)"/>
                        </div>
                    </div>
                </div> -->
                <div class="contractSelect" style="margin-top: 50px;">备注(选填)</div>
                <div class="invoiceInput">
                    <textarea class="invocieContent" placeholder="请输入订单备注(不超过100字)" v-model="clientNotes" maxlength="100"></textarea>
                </div>
                <!-- <div v-if="storeCouponCount>0">
                    <div class="contractSelect" style="margin-top: 50px;">使用优惠券</div>
                    <div class="coupon">
                        <div v-for="(item,index) in storeCouponList" :key="'storeCouponList'+index" style="display: inline-block;">
                            <img src="../../assets/buyCountyProduction/9折未选中.png" alt="" width="322" class="couponCon" @click="useCoupon(item,index)"
                            v-if="!storeCouponUseList[index]&&item.discountRate==9&&(currentDate.getTime()>=new Date(item.startTime).getTime())&&(currentDate.getTime()<=new Date(item.activeLife).getTime())&&areaPrice>=item.moneyLimit">
                            <img src="../../assets/buyCountyProduction/9折选中.png" alt="" width="322" class="couponCon" @click="useCoupon(item,index)"
                            v-if="storeCouponUseList[index]&&item.discountRate==9&&(currentDate.getTime()>=new Date(item.startTime).getTime())&&(currentDate.getTime()<=new Date(item.activeLife).getTime())&&areaPrice>=item.moneyLimit">
                            <img src="../../assets/buyCountyProduction/9折不可选.png" alt="" width="322" class="couponCon"
                            v-if="item.discountRate==9&&((currentDate.getTime()<new Date(item.startTime).getTime())||areaPrice<item.moneyLimit)">
                            <img src="../../assets/buyCountyProduction/8折未选中.png" alt="" width="322" class="couponCon" @click="useCoupon(item,index)"
                            v-if="!storeCouponUseList[index]&&item.discountRate==8&&(currentDate.getTime()>=new Date(item.startTime).getTime())&&(currentDate.getTime()<=new Date(item.activeLife).getTime())&&areaPrice>=item.moneyLimit">
                            <img src="../../assets/buyCountyProduction/8折选中.png" alt="" width="322" class="couponCon" @click="useCoupon(item,index)"
                            v-if="storeCouponUseList[index]&&item.discountRate==8&&(currentDate.getTime()>=new Date(item.startTime).getTime())&&(currentDate.getTime()<=new Date(item.activeLife).getTime())&&areaPrice>=item.moneyLimit">
                            <img src="../../assets/buyCountyProduction/8折不可选.png" alt="" width="322" class="couponCon"
                            v-if="item.discountRate==8&&((currentDate.getTime()<new Date(item.startTime).getTime())||areaPrice<item.moneyLimit)">
                        </div>
                    </div>
                    <div class="couponText" v-if="usedCoupon">优惠券折扣金额：<span>￥{{  accountPrice2 }}</span></div>
                </div> -->
            </div>

            <div class="contractInfo" style="height: 425px;">
                 <!-- 2025双十一 -->
                 <!-- <div class="contractSelect" style="margin-top: 50px;">使用兑换码
                    <div class="codeTip">提示：每名用户限用一次，仅支持在购买25km²季度图单个图源时使用，活动时间11月5日00:00:00-11月11日23:59:59。</div>
                </div> -->
                <!-- <div class="contractSelect1">
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;" v-if="codeSel==0">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 19px;cursor: pointer;" v-if="codeSel==1" @click="changeCodeSel(0)">
                    <div class="contractText1">使用兑换码
                        <span style="font-size:12px;color: #8C8C8C;" v-if="redeemCode&&canUseCode">({{ redeemCode }})</span>
                        <span style="font-size:12px;color: #8C8C8C;" v-else>(暂无可用兑换码)</span>
                    </div>
                    <img src="../../assets/countyQB/单选_选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 320px;" v-if="codeSel==1">
                    <img src="../../assets/countyQB/单选_未选中.png" alt="" style="position: absolute;width: 18px;height: 18px;top: 1px;left: 320px;cursor: pointer;" v-if="codeSel==0" @click="changeCodeSel(1)">
                    <div class="contractText1" style="left: 347px;">不使用兑换码</div>
                </div> -->
                <div class="totalText1">总计</div>
                <div class="totalText2" v-if="codeSel==1">应付价格：<span style="color:#FF4040 ;">￥{{ areaPrice }}</span> </div>
                <div class="totalText2" v-if="codeSel==0">应付价格：<span style="color:#FF4040 ;">￥0.01</span> </div>
                <div class="totalButton" @click="orderSubmit()">提交订单</div>
            </div>
            <div class="greyText2">若您有任何疑问请咨询商务经理：0431-86008580</div>
        </div>
        <div class="footerWhite">
            <div class="text">
                © 2023-2026 长光卫星技术股份有限公司 版权所有 |
                <span @click="goPrivacyPolicy()" style="cursor: pointer">隐私协议</span>
                |
                <span @click="goServiceAgreement()" style="cursor: pointer"
                >服务条款</span
                >
            </div>
        </div>
        <div class="shadow" v-if="isShadow==1">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowText1">专业版套件产品价格说明</div>
                <div class="shadowText3">2026年每季度一期、2025年每两个月一期（0.5m分辨率）：<br>选择行政区域情形的价格为￥10/km²/年，自定义矢量（绘制区域、上传矢量）情形的价格为￥13/km²/年</div>
                <div class="shadowText3" style="top: 180px;">2024、2023年每季度一期（0.75m分辨率）：<br>选择行政区域情形的价格为￥3/km²/年，自定义矢量（绘制区域、上传矢量）情形的价格为￥4/km²/年</div>
                <div class="shadowText2" style="top: 260px;">如有您对价格存疑，请联系商务经理：0431-86008580 ( 非节假日 08:30 ~ 17:30 )</div>
                <div class="shadowButton" @click="isShadow=0">关闭</div>
                <!--  -->
            </div>
        </div>
        <div class="shadow" v-if="isShadow==2">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0;$router.push('/buyCountyProduction');">
                <div class="shadowText1">请检查并重新下单</div>
                <div class="shadowText2">亲爱的用户，平台检测到您的订单中包含曾购买过的区域季度影像，请您检查历史订单后重新下单。<br>如有任何疑问请联系商务经理：0431-86008580 ( 非节假日 08:30 ~ 17:30 )。</div>
                <div class="shadowButton" @click="isShadow=0;$router.push('/buyCountyProduction');">关闭</div>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from "gsap";

export default {
    name:"demandConfirm",
    data(){
        return{
            areaLength:0,
            countyRepositoryBaseBoList:[],
            areaId:'',
            areaName:'',
            areaSize:'',
            areaQuarter:'',
            areaPrice:'',
            areaImg:'',
            contractType:"电子",
            clientName:'',
            clientNotes:'',
            redTip1:0,
            redTip2:0,
            invoiceType:1,
            qyCompany:"",
            qyNumber:"",
            zpCompany:"",
            zpNumber:"",
            address:"",
            phone:"",
            bank:"",
            bankNumber:"",
            isShadow:0,
            //优惠券列表
            storeCouponList:[],
            currentDate:'',
            storeCouponCount:0,
            storeCouponUseList:[],
            usedCoupon:false,
            accountPrice1:'',
            accountPrice2:'',
            storeCouponId:'',
            showSellerInfoStatus:'1',
            //2025双十一
            canUseCode:false,
            codeSel:1,//1不使用兑换码，0使用
            redeemCode:"",

    }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
        goPrivacyPolicy() {
            window.open("http://jl1mall.com/PrivacyPolicy", "_self");
        },
        goServiceAgreement() {
            window.open("http://jl1mall.com/ServiceAgreement", "_self");
        },
        orderSubmit(){
            let canApply1 = false
            let canApply2 = false
            if(this.clientName==''){
                this.redTip1=1
                let redTip1Id = document.getElementById("redTip1Id")
                redTip1Id.style.opacity=1
                setTimeout(() => {
                    gsap.to('#redTip1Id',{duration:1, opacity:0})
                }, 5000);
                let contractNameId = document.getElementById("contractNameId")
                contractNameId.style.color="#FF4040"
                let contractInputId = document.getElementById("contractInputId")
                contractInputId.style.borderBottom="2px solid #FF4040"
            }
            if(this.invoiceType==2){
                if(this.qyCompany!=''&&this.qyNumber!=''){
                    canApply1=true
                }
                if(this.qyCompany==''||this.qyNumber==''){
                    this.redTip2=1
                    let redTip2Id = document.getElementById("redTip2Id")
                    redTip2Id.style.opacity=1
                    setTimeout(() => {
                        gsap.to('#redTip2Id',{duration:1, opacity:0})
                    }, 5000);
                }
                if(this.qyCompany==''){
                    let qyText1Id = document.getElementById("qyText1Id")
                    qyText1Id.style.color="#FF4040"
                    let greyInput1Id = document.getElementById("greyInput1Id")
                    greyInput1Id.style.border="2px solid #FF4040"
                }
                if(this.qyNumber==''){
                    let qyText2Id = document.getElementById("qyText2Id")
                    qyText2Id.style.color="#FF4040"
                    let greyInput2Id = document.getElementById("greyInput2Id")
                    greyInput2Id.style.border="2px solid #FF4040"
                }
            }
            if(this.invoiceType==3){
                if(this.zpCompany!=''&&this.zpNumber!=''&&this.address!=''&&this.phone!=''&&this.bank!=''&&this.bankNumber!=''){
                    canApply2=true
                }
                if(this.zpCompany==''||this.zpNumber==''||this.address==''||this.phone==''||this.bank==''||this.bankNumber==''){
                    this.redTip2=1
                    let redTip2Id = document.getElementById("redTip2Id")
                    redTip2Id.style.opacity=1
                    setTimeout(() => {
                        gsap.to('#redTip2Id',{duration:1, opacity:0})
                    }, 5000);
                }
                if(this.zpCompany==''){
                    let qyText3Id = document.getElementById("qyText3Id")
                    qyText3Id.style.color="#FF4040"
                    let greyInput3Id = document.getElementById("greyInput3Id")
                    greyInput3Id.style.border="2px solid #FF4040"
                }
                if(this.zpNumber==''){
                    let qyText4Id = document.getElementById("qyText4Id")
                    qyText4Id.style.color="#FF4040"
                    let greyInput4Id = document.getElementById("greyInput4Id")
                    greyInput4Id.style.border="2px solid #FF4040"
                }
                if(this.address==''){
                    let qyText5Id = document.getElementById("qyText5Id")
                    qyText5Id.style.color="#FF4040"
                    let greyInput5Id = document.getElementById("greyInput5Id")
                    greyInput5Id.style.border="2px solid #FF4040"
                }
                if(this.phone==''){
                    let qyText6Id = document.getElementById("qyText6Id")
                    qyText6Id.style.color="#FF4040"
                    let greyInput6Id = document.getElementById("greyInput6Id")
                    greyInput6Id.style.border="2px solid #FF4040"
                }
                if(this.bank==''){
                    let qyText7Id = document.getElementById("qyText7Id")
                    qyText7Id.style.color="#FF4040"
                    let greyInput7Id = document.getElementById("greyInput7Id")
                    greyInput7Id.style.border="2px solid #FF4040"
                }
                if(this.bankNumber==''){
                    let qyText8Id = document.getElementById("qyText8Id")
                    qyText8Id.style.color="#FF4040"
                    let greyInput8Id = document.getElementById("greyInput8Id")
                    greyInput8Id.style.border="2px solid #FF4040"
                }
            }
            var userInfo={}
            if(this.invoiceType==1){
                let invoiceType="gr"
                userInfo = {
                    name:this.$store.state.county.name,
                    age: this.$store.state.county.age,
                    company: this.$store.state.county.company,
                    education: this.$store.state.county.education,
                    sex: this.$store.state.county.sex,
                    contractType:this.contractType,
                    userClientName: this.clientName,
                    areaId:this.areaId,
                    countyRepositoryBaseBoList:this.countyRepositoryBaseBoList,
                    invoiceType: invoiceType,
                    invoiceJson:{},
                    remark:this.clientNotes,
                    storeCouponId:this.storeCouponId
            };
            }else if(this.invoiceType==2){
                let invoiceType="qy"
                userInfo = {
                    name:this.$store.state.county.name,
                    age: this.$store.state.county.age,
                    company: this.$store.state.county.company,
                    education: this.$store.state.county.education,
                    sex: this.$store.state.county.sex,
                    contractType:this.contractType,
                    userClientName: this.clientName,
                    areaId:this.areaId,
                    countyRepositoryBaseBoList:this.countyRepositoryBaseBoList,
                    invoiceType: invoiceType,
                    invoiceJson:{
                        number:this.qyNumber,
                        companyName:this.qyCompany
                    },
                    remark:this.clientNotes,
                    storeCouponId:this.storeCouponId,
                    showSellerInfoStatus:this.showSellerInfoStatus,
                };
            }else if(this.invoiceType==3){
                let invoiceType="zp"
                userInfo = {
                    name:this.$store.state.county.name,
                    age: this.$store.state.county.age,
                    company: this.$store.state.county.company,
                    education: this.$store.state.county.education,
                    sex: this.$store.state.county.sex,
                    contractType:this.contractType,
                    userClientName: this.clientName,
                    areaId:this.areaId,
                    countyRepositoryBaseBoList:this.countyRepositoryBaseBoList,
                    invoiceType: invoiceType,
                    invoiceJson:{
                        number:this.zpNumber,
                        companyName:this.zpCompany,
                        address:this.address,
                        phone:this.phone,
                        bank:this.bank,
                        bankNumber:this.bankNumber,
                    },
                    remark:this.clientNotes,
                    storeCouponId:this.storeCouponId,
                    showSellerInfoStatus:this.showSellerInfoStatus,
                };
            }
            if(this.$store.state.county.tabSel==3||this.$store.state.county.tabSel==4){
                userInfo.countyName=this.$store.state.county.customizeName
                userInfo.shape=this.$store.state.county.shape
            }
            if(this.codeSel==0){
                userInfo.redeemCode=this.redeemCode
            }
            if(this.clientName!=''){
                if(this.invoiceType==1||(this.invoiceType==2&&canApply1)||(this.invoiceType==3&&canApply2)){
                    this.axios.post("/tilesapi/tiles/register/addCountyTileOrder",userInfo, {
                        headers: {
                        Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.$router.push({path: "/demandSubmit",query: {'id':res.data.msg}});
                        }else{
                            if(res.data.msg=='已购买过该区域专业版订单!'){
                                this.isShadow=2
                            }else{
                                alert(res.data.msg)
                            }
                        }
                    })
                }
            }

        },
        inputBlack(i){
            if(i==1){
                let contractNameId = document.getElementById("contractNameId")
                contractNameId.style.color="#3A3A3A"
                let contractInputId = document.getElementById("contractInputId")
                contractInputId.style.borderBottom="1px solid #3A3A3A"
            }else if(i==2){
                let qyText1Id = document.getElementById("qyText1Id")
                qyText1Id.style.color="#3A3A3A"
                let greyInput1Id = document.getElementById("greyInput1Id")
                greyInput1Id.style.border="1px solid #3A3A3A"
            }else if(i==3){
                let qyText2Id = document.getElementById("qyText2Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput2Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }else if(i==4){
                let qyText2Id = document.getElementById("qyText3Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput3Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }else if(i==5){
                let qyText2Id = document.getElementById("qyText4Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput4Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }else if(i==6){
                let qyText2Id = document.getElementById("qyText5Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput5Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }else if(i==7){
                let qyText2Id = document.getElementById("qyText6Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput6Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }else if(i==8){
                let qyText2Id = document.getElementById("qyText7Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput7Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }else if(i==9){
                let qyText2Id = document.getElementById("qyText8Id")
                qyText2Id.style.color="#3A3A3A"
                let greyInput2Id = document.getElementById("greyInput8Id")
                greyInput2Id.style.border="1px solid #3A3A3A"
            }

        },
        changeChinese(i){
            if(i==1){
                return '一'
            }else if(i==2){
                return '二'
            }else if(i==3){
                return '三'
            }else if(i==4){
                return '四'
            }
        },
        //优惠券
        getUserStoreCoupon(){
            this.axios
                .get("/accessapi/store/coupon/getUserStoreCoupon",{
                headers: {
                    Authorization: "Bearer " + this.getKey(),}
                }).then((res) => {
                    this.storeCouponList = res.data.data
                    this.storeCouponUseList=[]
                    for(let i=0;i<this.storeCouponList.length;i++){
                        this.storeCouponUseList.push(false)
                    }
                    let currentDate = new Date()
                    // let currentDate=new Date('2024-11-12')
                    let storeCouponCount = 0
                    for(let i=0;i<this.storeCouponList.length;i++){
                        if(currentDate.getTime()<=new Date(this.storeCouponList[i].activeLife).getTime()){
                            storeCouponCount++
                        }
                    }
                    this.storeCouponCount=storeCouponCount

            })
        },
        //使用优惠券
        useCoupon(item,index){
            //取消使用优惠券
            if(this.storeCouponUseList[index]){
                this.storeCouponUseList[index]=false
                this.usedCoupon=false
                this.storeCouponId=''
            }
            //使用优惠券
            else{
                for(let i=0;i<this.storeCouponUseList.length;i++){
                    this.storeCouponUseList[i]=false
                    this.storeCouponId=''
                }
                this.storeCouponUseList[index]=true
                this.usedCoupon=true
                let account1 = item.discountRate*0.1
                let account2 =(10-item.discountRate)*0.1
                this.accountPrice1 = this.jsmultiplication(this.areaPrice,account1)
                this.accountPrice2 = this.jsmultiplication(this.areaPrice,account2)
                this.storeCouponId=item.id
            }
            this.$forceUpdate();
        },
        jsmultiplication(arg1, arg2){
            //解决小数相乘精度问题的方法
            let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
            try {
            m += s1.split(".")[1].length;
            }
            catch (e) {
                console.log(e);
            }
            try {
            m += s2.split(".")[1].length;
            }
            catch (e) {
                console.log(e);
            }
            return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
        },
        //2025双十一
        getUserCode(){
            this.axios.get("/dhm_back/redeem/code/verifeActivity",{
                headers: {
                    Authorization: "Bearer " + this.getKey(),}
                }).then((res) => {
                    if(res.data.code==200){
                        if(res.data.data){
                            this.axios.get("/dhm_back/redeem/code/getUserCode",{
                                headers: {
                                    Authorization: "Bearer " + this.getKey(),}
                                }).then((response) => {
                                    if(response.data.code==200){
                                        this.redeemCode=response.data.data.code
                                        if(response.data.data.available&&this.$store.state.county.areaSel==2&&
                                        this.$store.state.county.selectedQuanterIds.length==1){
                                            this.canUseCode=true
                                            this.codeSel=0
                                        }else{
                                            this.canUseCode=false
                                            this.codeSel=1
                                        }
                                    }else{
                                        this.canUseCode=false
                                        this.codeSel=1
                                    }
                            })
                        }else{
                            this.canUseCode=false
                            this.codeSel=1
                        }
                    }
                })
        },
        changeCodeSel(i){
            if(this.canUseCode){
                this.codeSel=i
            }
        }

    },
    mounted(){
        this.toPageTop()
        let county = this.$store.state.county
        this.areaLength=county.selectedQuanterItems.length
        this.areaId=county.selectedQuanterItems[0].areaId
        for(let i=0;i<county.selectedQuanterItems.length;i++){
            this.countyRepositoryBaseBoList.push({
                year:county.selectedQuanterItems[i].year,
                sort:county.selectedQuanterItems[i].sort
            })
        }
        if(county.tabSel==3||county.tabSel==4){
            this.areaName=county.customizeName
        }else{
            this.areaName=county.selectedQuanterItems[0].areaName
        }
        this.areaSize=county.selectedQuanterItems[0].area.toFixed(2)
        this.areaPrice=county.selectedSumPrices
        this.areaImg=county.img
        this.areaQuarter =county.selectedQuanterIds.join('、')
        // this.getUserCode()
        // this.getUserStoreCoupon()
    },
    created(){
        let currentDate = new Date()
        this.currentDate=currentDate
    }

}
</script>

<style scoped>
.greyBody{
    position: relative;
    margin-top: 76px;
    width: 100%;
    height: auto;
    background: #F5F5F6;
    overflow: hidden;
}
.goback{
    position: absolute;
    height: 18px;
    width: 60px;
    top: 62px;
    left: calc(50% - 640px);
    cursor: pointer;
}
.gobackText{
    position: absolute;
    left: 15px;
    width: 50px;
    height: 18px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 18px;
}
.greyText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 200px);
    width: 400px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.jindutiao{
    position: absolute;
    width: 1280px;
    height: 55px;
    top: 142px;
    left: calc(50% - 640px);
}
.jindutiaoText1{
    position: absolute;
    top: 35px;
    left: 242px;
    width: 76px;
height: 16px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 16px;
text-align: center;
}
.jindutiaoLine1{
   position: absolute;
   top: 14px;
   left: 292px;
   width: 78px;
    height: 1px;
    border-top: 2px solid #0066CC;
}
.jindutiaoLine2{
    position: absolute;
    top: 15px;
    left: 370px;
    width: 75px;
    height: 2px;
    border-top: 1px solid #CCCCCC;

}
.jindutiaoText2{
    position: absolute;
    left: 422px;
    top: 35px;
    width: 76px;
height: 16px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #B8B8B8;
line-height: 16px;
text-align: center;
}
.orderInfo{
    position: relative;
    margin-top: 274px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height:384px;
    background: #FFFFFF;
    border-radius: 16px;
    overflow: hidden;
}
.orderBlue{
    position: absolute;
    width: 1280px;
    height: 54px;
    background: rgba(0,102,204,0.5);
    border-radius: 16px 16px 0px 0px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    text-align: center;
}
.orderImgText{
    position: absolute;
    top: 334px;
    left: 152px;
    width: 130px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0066CC;
    line-height: 20px;
    cursor: pointer;
}
.orderText1{
    position: relative;
    margin-left: 505px;
    margin-bottom: 20px;
    width: 750px;
    height: auto;
    min-height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 20px;
}
.orderText2{
    position: absolute;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 20px;
}
.orderText3{
    position: absolute;
    width: 650px;
    height: auto;
    left: 111px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
}
.contractInfo{
    position: relative;
    margin-top: 20px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: auto;
    background: #FFFFFF;
    border-radius: 16px;
    overflow: hidden;
}
.greyInvoice{
    position: relative;
    margin-top: 20px;
    margin-left: 52px;
    width: 1175px;
    height: 1px;
    /* background-color: plum; */
    overflow: hidden;
}
.greyInvoice1{
    position: relative;
    margin-top: 20px;
    margin-left: 52px;
    width: 1100px;
    height: 170px;
    overflow: hidden;
}
.greyInvoice2{
    position: relative;
    margin-top: 20px;
    margin-left: 52px;
    width: 1100px;
    height: 430px;
    overflow: hidden;
}
.qyInvoice{
    position: absolute;
    width: 1175px;
    height: 100px;
}
.zpInvoice{
    position: absolute;
    top: 0;
    left: 0;
    width: 1175px;
    height: 400px;
}
.qyText1{
    position: absolute;
    top: 10px;
    left: 240px;
    width: 200px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
    text-align: right;
}
.greyInput{
    position: absolute;
    top: 0px;
    left: 445px;
    width: 380px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.greyRemarks{
    position: absolute;
    top: 0px;
    left: 445px;
    width: 380px;
    height: 40px;
    border-radius: 8px;
  }
.inputContent{
  position: absolute;
  top: 5px;
    left: 5px;
  width: 370px;
height: 30px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3a3a3a;
line-height: 30px;
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.zpLine{
    position: absolute;
    top: 170px;
    left: 350px;
    width: 500px;
    height: 1px;
    border-bottom: 1px #979797 dashed;
}
.zpText1{
    position: absolute;
    top: 161px;
    left: 570px;
    width: 80px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color:  #3A3A3A;
    line-height: 20px;
    text-align: center;
    background-color: #fff;
}
.contractSelect{
    position: relative;
    margin-top: 104px;
    margin-left: 60px;
    padding-left: 20px;
    width: 1160px;
height: 54px;
background: #F5F5F6;
border-radius: 8px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1D1D28;
line-height: 54px;
}
.redTip{
    position: absolute;
    top: 7px;
    left: calc(50% - 300px);
    width: 600px;
    height: 40px;
    background: #FF4040;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    opacity: 1;
}
.contractSelect1{
    position: relative;
    width: 1160px;
    height: 47px;
    margin-top: 55px;
    margin-left: 60px;
    /* background-color: pink; */
}
.contractText1{
    position: absolute;
    left: 45px;
    width: 256px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
}
.contractText2{
    position: absolute;
    top: 30px;
    left: 45px;
    width:40px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 17px;
}
.contractName{
    margin-top: 50px;
    margin-left: 81px;
    width: 256px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
}
.contractInput{
    position: relative;
    margin-top: 25px;
    margin-left: 80px;
    width: 1110px;
    height: 30px;
    border-bottom: 1px solid #3A3A3A;
}
.conInputContent{
    position: absolute;
    top: 5px;
    width: 1000px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight:500;
    color: #3A3A3A;
    line-height: 20px;
    border:none;
    outline: none;
}
.invoiceInput{
    position: relative;
    margin-top: 10px;
    margin-left: 60px;
    margin-bottom: 50px;
    width: 1160px;
    height: 150px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.1);
}
.invocieContent{
    position: absolute;
    top: 18px;
    left: 20px;
    width: 1120px;
    height: 120px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight:500;
    color: #3A3A3A;
    line-height: 20px;
    border:none;
    outline: none;
    resize: none;
}
.totalText1{
    position: absolute;
    margin-top: 30px;
    margin-left: 80px;
    width: 50px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 22px;
}
.totalText2{
    position: absolute;
    top: 240px;
    right:63px;
    width: 200px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 22px;
    text-align: right;
}
.totalButton{
    position: absolute;
    top: 320px;
    right: 60px;
    width: 150px;
height: 44px;
background: #0066CC;
border-radius: 8px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.greyText2{
    margin: 100px auto;
    width: 1280px;
    height: 25px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.footerWhite{
    position: relative;
    width: 100%;
    height: 120px;
    background: #FFFFFF;
}
.text {
  position: absolute;
  top: 50px;
  left: calc(50% - 350px);
  width: 700px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 17px;
  text-align: center;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowText1{
    position: absolute;
    top:50px;
    width: 800px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 28px;
text-align: center;

}
.shadowText2{
    position: absolute;
    top:128px;
    left:0px;
    width: 800px;
    height: 75px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #3A3A3A;
    line-height: 25px;
    text-align: center;

}
.shadowText3{
    position: absolute;
    top:128px;
    left:50px;
    width:700px;
    height: 75px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #3A3A3A;
    line-height: 25px;
    text-align: left;

}
.shadowButton{
    position: absolute;
    top: 310px;
    left: calc(50% - 48px);
    width: 92px;
height: 40px;
background: #0066CC;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.coupon{
    position: relative;
    margin-top: 30px;
    margin-left: 60px;
    margin-bottom: 50px;
    width: 1160px;
    height: auto;
}
.couponCon{
    display: inline-block;
    width: 322px;
    height: 82px;
    margin-right: 40px;
    margin-bottom: 20px;
    cursor: pointer;
}
.couponText{
    position: relative;
    margin-left: 60px;
    margin-bottom: 50px;
    width: auto;
    height: 21px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 14px;
}
</style>
<style scoped>
.codeTip{
    position: absolute;
    top: 0;
    left:120px;
    width: auto;
    height: 54px;
    line-height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #FF3A3A;
    text-align: left;
}

</style>
